import axios from "axios";
import { API } from "@/App";
import { tokenStore } from "@/lib/token";

// Vanta AI : appels au backend du site (/api/vai). Les réponses du modèle
// arrivent en streaming (Server-Sent Events lus avec fetch).

const auth = () => ({ Authorization: `Bearer ${tokenStore.get()}` });

export const vai = {
  get: (path, params) => axios.get(`${API}/vai${path}`, { headers: auth(), params }).then((r) => r.data),
  post: (path, body) => axios.post(`${API}/vai${path}`, body || {}, { headers: auth() }).then((r) => r.data),
  put: (path, body) => axios.put(`${API}/vai${path}`, body || {}, { headers: auth() }).then((r) => r.data),
  patch: (path, body) => axios.patch(`${API}/vai${path}`, body || {}, { headers: auth() }).then((r) => r.data),
  del: (path) => axios.delete(`${API}/vai${path}`, { headers: auth() }).then((r) => r.data),
};

export const errorText = (err, fallback = "Une erreur est survenue") => err?.response?.data?.detail || err?.message || fallback;

/**
 * Envoie un message et lit la réponse au fil de l'eau.
 * onEvent(name, data) est appelé pour chaque événement : start, text,
 * tool_start, tool, error, done. Renvoie une promesse terminée à la fin.
 */
export async function streamMessage(chatId, body, onEvent, signal) {
  const res = await fetch(`${API}/vai/chats/${chatId}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...auth() },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok) {
    let detail = "Le message n'a pas pu être envoyé";
    try { detail = (await res.json()).detail || detail; } catch { /* réponse sans JSON */ }
    const error = new Error(detail);
    error.status = res.status;
    throw error;
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let cut;
    while ((cut = buffer.indexOf("\n\n")) >= 0) {
      const raw = buffer.slice(0, cut);
      buffer = buffer.slice(cut + 2);
      let name = "message";
      let data = "";
      raw.split("\n").forEach((line) => {
        if (line.startsWith("event: ")) name = line.slice(7);
        else if (line.startsWith("data: ")) data += line.slice(6);
      });
      if (!data) continue;
      try { onEvent(name, JSON.parse(data)); } catch { /* morceau illisible ignoré */ }
    }
  }
}

export const MODEL_INFO = {
  pulse: { name: "Pulse", tagline: "Rapide, pour le quotidien" },
  vector: { name: "Vector", badge: "Vanta Code", tagline: "Le plus puissant : code, projets .zip, 3D" },
};

export function greeting(name) {
  const h = new Date().getHours();
  const hello = h >= 18 || h < 5 ? "Bonsoir" : "Bonjour";
  return name ? `${hello}, ${name}` : hello;
}

export function resetIn(iso) {
  if (!iso) return "";
  const ms = new Date(iso).getTime() - Date.now();
  if (ms <= 0) return "maintenant";
  const h = Math.floor(ms / 3600000);
  const m = Math.max(1, Math.round((ms % 3600000) / 60000));
  if (h >= 24) return `dans ${Math.round(h / 24)} j`;
  return h ? `dans ${h} h ${String(m).padStart(2, "0")}` : `dans ${m} min`;
}
